module.exports = __webpack_public_path__ + "img/black.d42949cd.svg";